import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import InformationMessage from "../../entity/user/InformationMessage";
import isNull from "../../mixin/isNull";

const SERVICE = "service-user";
const ENTITY = "information_messages";

export default function () {
    const {findAllBy} = useApi();
    const state = useSelector;
    const newInstance = data => new InformationMessage(data);

    return {
        findAllByRecipientType(recipientType) {
            return {
                select() {
                    const result = state(state => state.api?.user?.[ENTITY]?.filter(im => im?.getRecipientType() === recipientType));

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    findAllBy(SERVICE, ENTITY, "recipient_type", recipientType, newInstance, "entrepreneur");
                }
            }
        }
    }
}